import React from "react";
import EditRequirements from "../components/EditRequirements/EditRequirements.tsx";

const EditRequirementsPage = () => {
  return <EditRequirements />;
};

export default EditRequirementsPage;
